import React from 'react';
import { Controlled as CodeMirror } from 'react-codemirror2';
// 导入样式
import 'codemirror/lib/codemirror.css';
// 导入语言
import 'codemirror/mode/javascript/javascript';
import 'codemirror/mode/css/css';
// 导入ctrl+空格提示
import 'codemirror/addon/hint/show-hint.css';
import 'codemirror/addon/hint/show-hint.js';
// 导入提示语言类型
import 'codemirror/addon/hint/javascript-hint.js';
// 导入theme主题
// import 'codemirror/theme/ambiance.css';
import 'codemirror/theme/monokai.css';

import 'codemirror/keymap/sublime';
import 'codemirror/addon/display/autorefresh';
import 'codemirror/addon/comment/comment';
import 'codemirror/addon/edit/matchbrackets';

import 'codemirror/addon/fold/foldgutter.css';
import 'codemirror/addon/fold/foldcode.js';
import 'codemirror/addon/fold/foldgutter.js';
import 'codemirror/addon/fold/brace-fold.js';
import 'codemirror/addon/fold/comment-fold.js';
import 'codemirror/addon/edit/matchbrackets.js';
import 'codemirror/addon/edit/closebrackets.js';

import 'codemirror/addon/lint/lint.js';
import 'codemirror/addon/lint/lint.css';
import 'codemirror/addon/lint/javascript-lint.js';

import 'codemirror/addon/scroll/annotatescrollbar.js';
import 'codemirror/addon/search/matchesonscrollbar.js';
import 'codemirror/addon/search/matchesonscrollbar.css';
import 'codemirror/addon/search/searchcursor.js';
import 'codemirror/addon/search/match-highlighter.js';

import { sgiLogger } from 'rt-sd-common/sgiCommon/sgiLogger';
import { SgiEventHandler } from './SgiEventHandler';
import SgiCtlComponent from './sgiBaseComp/SgiCtlComponent';

export default class SgiCodeMirror extends SgiCtlComponent {

	constructor(props) {
		super(props);
		this.state = {
			...this.state,
			_class: ["sgi-codemirror"],
			functions: {}
		};
	}

	__AddAttribute() {

		let { parentModule, moduleDesc, bdInst, objFct, type } = this.props;
		let { _props, _class } = this.state;

		let options = _props.options = {
			mode: 'javascript',//语言
			theme: 'monokai',//主题
			keyMap: 'sublime',
			lineNumbers: true,                     //显示行号  
			extraKeys: { "Ctrl": "autocomplete" },   //自动提示配置  
			lineWrapping: true, //代码折叠
			foldGutter: true,
			// showHint: true,
			// highlightSelectionMatches: true,
			highlightSelectionMatches: { showToken: /\w/, annotateScrollbar: true },
			// extraKeys: { "Ctrl-/": "autocomplete" },
			hintOptions: { schemaInfo: [] },
			lint: true,
			gutters: ["CodeMirror-linenumbers", "CodeMirror-foldgutter",
				'CodeMirror.hint.javascript', 'CodeMirror.hint.coffeescript', 'CodeMirror-lint-markers'],
			matchBrackets: true,	//括号匹配
			autoCloseBrackets: true, //关闭
			tabSize: 4,
		};

		if (!moduleDesc) return;
		if (moduleDesc.cstmOptions) {
			let cstmOptions = eval(`(${moduleDesc.cstmOptions})`);
			if (cstmOptions) {
				Object.assign(options, cstmOptions);
			}
		}
		// if (moduleDesc.mode) options.mode = moduleDesc.mode;
		// if (moduleDesc.lineSeparator) options.lineSeparator = moduleDesc.lineSeparator;
		// if (moduleDesc.theme) options.theme = moduleDesc.theme;
		// if (moduleDesc.indentUnit) options.indentUnit = moduleDesc.indentUnit;
		// if (moduleDesc.smartIndent) options.smartIndent = moduleDesc.smartIndent;
		// if (moduleDesc.tabSize) options.tabSize = moduleDesc.tabSize;
		// if (moduleDesc.indentWithTabs) options.indentWithTabs = moduleDesc.indentWithTabs;
		// if (moduleDesc.electricChars) options.electricChars = moduleDesc.electricChars;
		// if (moduleDesc.specialChars) options.specialChars = moduleDesc.specialChars;
		// if (moduleDesc.specialCharPlaceholder) options.specialCharPlaceholder = moduleDesc.specialCharPlaceholder;
		// if (moduleDesc.direction) options.direction = moduleDesc.direction;
		// if (moduleDesc.rtlMoveVisually) options.rtlMoveVisually = moduleDesc.rtlMoveVisually;
		// if (moduleDesc.keyMap) options.keyMap = moduleDesc.keyMap;
		// if (moduleDesc.extraKeys) options.extraKeys = moduleDesc.extraKeys;
		// .
		// .
		// .
		// 太多了，写不过来了

	}

	__bindEvent() {
		let { parentModule, moduleDesc = {}, bdInst, objFct, type } = this.props;
		let { _props, _class } = this.state;
		let { functions } = this.data;

		_props.onBeforeChange = (editor, data, value) => {
			_props.value = value;
			this.setState({});
		}

		//onchange
		var chgLsn = moduleDesc.chgLsn;
		if (chgLsn) {
			var $chgLsn;
			try {
				$chgLsn = new Function("module", "objFct", "value", "data", "editor", chgLsn);
				// $chgLsn = new Function("module", "objFct", "record", "nv", "nt", "itemData", "extra", chgLsn);
				// $chgLsn = new Function("module", "objFct", "record", "nv", "data", "editor", chgLsn);
			} catch (error) {
				sgiLogger.eventErr(error);
			}
			functions.onChange = $chgLsn;
			// _props.onChange = (editor, data, value) => {
			// 	if ($chgLsn) $chgLsn(this, objFct, value, data, editor);
			// };
		}
		_props.onChange = SgiEventHandler.onCodeMirrorChange.bind(this);
		// _props.onChange = SgiEventHandler.onChange.bind(this, this);
	}

	__render = () => <CodeMirror {...this.state._props} />

}





// WEBPACK FOOTER //
// ./~/rt-sd-comp/sgiComp/SgiCodeMirror.js